<template>
  <ul class="flex gap-4">
    <li v-for="link in links" :key="link.url" >
      <a :href="link.url" target="_blank">
        <KpImage :src="getIcon(link)" :alt="link.title" />
      </a>
    </li>
  </ul>
</template>

<script setup>
import links from "static/footer-social";
import { useScreenWidth } from "@/composables/useScreenWidth";
import { ScreenWidth } from "constants/screenWidth";
import KpImage from "components/elements/kp/KpImage.vue";
const {screenWidth} = useScreenWidth()

const getIcon = (link) => {
    return screenWidth.value === ScreenWidth.Desktop ? link.icon : link.iconGray
}
</script>

<style lang="scss" scoped></style>
